import React from 'react';
import PropTypes from 'prop-types';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { CloseIcon } from '../../close_icon/close_icon';
import styles from './exit_compare.css';

/**
 * Exit compare functional component
 * @param {Event} handleClick Handle click method
 * @constructor
 */
const ExitCompare = ({ handleClick }) => (
    <SimpleFlexbox contentCenter="xs">
        <div
            className={styles.container}
            onClick={handleClick}
            onKeyPress={handleClick}
            role="button"
            tabIndex="0"
        >
            Go back to all results
            <CloseIcon handleClick={handleClick} visualProps={{ variant: 'exit_compare' }} />
        </div>
    </SimpleFlexbox>
);

ExitCompare.propTypes = {
    handleClick: PropTypes.func.isRequired
};

export { ExitCompare };
